import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8v3a1 1 0 0 0 1 1h3","key":"svg-0"}],["path",{"d":"M14 8v8","key":"svg-1"}]]

const IconNumber4Small = createReactComponent('outline', 'number-4-small', 'Number4Small', __iconNode);

export default IconNumber4Small;